import AbstractPolyShape from "./AbstractPolyShape";

export default class Polygon extends AbstractPolyShape {
    type = 'polygon';

    constructor(provider, data, appearance, speciesIds, label) {
        super(provider, data, appearance, speciesIds, label);
        this.close = this.p.CLOSE;
    }

    clone(dx, dy) {
        return new Polygon(
            this.provider,
            {
                coordinates: this.coordinates.map((c) => [c.absX + dx, c.absY + dy]),
            },
            this.appearance.clone(),
            this.speciesIds,
            this.labels.clone(),
        );
    }

    hovered() {
        if (this.isInsidePolygon()) return true;
        return this.isNearEdge();
    }

    isInsidePolygon() {
        let passings = 0;
        for (let i = 0; i < this.coordinates.length; i++) {
            let c1 = this.coordinates[i];
            let c2 = this.coordinates[(i + 1) % this.coordinates.length];
            if (c1.currentY == c2.currentY) continue;
            if (c1.currentY < this.view.currentY && c2.currentY < this.view.currentY) continue;
            if (c1.currentY > this.view.currentY && c2.currentY > this.view.currentY) continue;
            let x = c1.currentX + (this.view.currentY - c1.currentY) * (c2.currentX - c1.currentX) / (c2.currentY - c1.currentY);
            if (x > this.view.currentX) passings++;
        }
        return passings % 2 == 1;
    }

    isNearEdge() {
        const tolerance = this.appearance.scaledStrokeWidth / 2;
        if (tolerance < 1) return false;
        const mx = this.view.currentX;
        const my = this.view.currentY;
        for (let i = 0; i < this.coordinates.length; i++) {
            const c1 = this.coordinates[i];
            const c2 = this.coordinates[(i + 1) % this.coordinates.length];
            if (this.distToSegment(mx, my, c1.currentX, c1.currentY, c2.currentX, c2.currentY) <= tolerance) {
                return true;
            }
        }
        return false;
    }

    distToSegment(px, py, x1, y1, x2, y2) {
        const dx = x2 - x1;
        const dy = y2 - y1;
        const lenSq = dx * dx + dy * dy;
        if (lenSq === 0) return this.p.dist(px, py, x1, y1);
        const t = Math.max(0, Math.min(1, ((px - x1) * dx + (py - y1) * dy) / lenSq));
        return this.p.dist(px, py, x1 + t * dx, y1 + t * dy);
    }

    getSegmentCoordinates(index) {
        return [
            this.coordinates[index],
            this.coordinates[(index + 1) % this.coordinates.length],
        ];
    }

    export() {
        return {
            type: 'polygon',
            data: {
                coordinates: this.coordinates.map((c) => [c.absX, c.absY]),
                notes: this.notes,
                ...this.appearance.export(),
                ...this.labels.export(),
            },
            speciesIds: this.speciesIds,
        }
    }

    isPolygon() {
        return true;
    }

    get length() {
        return this.coordinates.length;
    }

    get displayArea() {
        const n = this.coordinates.length;
        let area = 0;
        for (let i = 0; i < n; i++) {
            const j = (i + 1) % n;
            area += this.coordinates[i].absX * this.coordinates[j].absY;
            area -= this.coordinates[j].absX * this.coordinates[i].absY;
        }
        const factor = this.settings.metric ? 100 : 30.48;
        return Math.round(Math.abs(area) / 2 / (factor * factor) * 100) / 100;
    }

    get title() {
        return 'Free shape';
    }
}
